/*
  A javascript version of com.videx.misc.TimeOfDay.
  Do not use this constructor but instead use TimeOfDayFactory to
  create valid TimeOfDay instances.
*/
import {SuperSelect} from "./super-select";
import {CA_stringTrim} from "../../common/strings";
import {TimeOfDayFactory} from "../misc/time-of-day";

/*
  Easyforms TimeOfDayInput encapsulation class
  [public methods]
    setEnabled(enabled): enable or disable all composite inputs.
    getTimeOfDay(): get a TimeOfDay object representing the current input.  Returns null if the input is not a valid time of day.
    setTimeOfDay(newTimeOfDay): set the fields using the given TimeOfDay object

*/
export function TimeOfDayInput(formReference, easyFormsName) {
    this.frm = formReference;
    this.name = easyFormsName;

    /**return false if this TimeOfDayInput is not actually present in the form*/
    this.exists = function() {
        return this.frm.elements[this.name + "_txtHour"] != null;
    }

    this.get_txtHour = function() {
        return this.frm.elements[this.name + "_txtHour"];
    }

    this.get_txtMin = function() {
        return this.frm.elements[this.name + "_txtMin"];
    }

    /*
      @return null if the input is in 24 hour mode
    */
    this.get_selAMPM = function() {
        const sel = this.frm.elements[this.name + "_selAMPM"];
        if (sel)
            return sel;
        else
            return null;
    }

    this.setEnabled = function(enabled) {
        this.get_txtHour().disabled = !enabled;
        this.get_txtMin().disabled = !enabled;

        const sel = this.get_selAMPM();
        if (sel)
            sel.disabled = !enabled;
    }

    this.getTimeOfDay = function() {
        const hourTxt = this.get_txtHour().value;
        const minTxt = this.get_txtMin().value;

        const hour = parseInt(CA_stringTrim(hourTxt), 10);
        const min = parseInt(CA_stringTrim(minTxt), 10);

        //hour and minute are valid integers?
        if (!isNaN(hour) && !isNaN(min)) {
            const todFactory = new TimeOfDayFactory();

            const apElm = this.get_selAMPM();
            if (apElm) {
                const sel = new SuperSelect(apElm);
                const isMorning = sel.getSelectedOption().getValue() == "0";
                return todFactory.create12(hour, min, 0, isMorning);
            } else
                return todFactory.create24(hour, min, 0);
        }
        else
            return null;
    }

    this.setTimeOfDay = function(newTimeOfDay) {
        let ampmSelect = null;
        let apElm = this.get_selAMPM();
        if (apElm)
            ampmSelect = new SuperSelect(apElm);

        let hourElm = this.get_txtHour();
        let minElm = this.get_txtMin();

        //12 hour time
        if (ampmSelect != null) {
            hourElm.value = newTimeOfDay.getHourOfDay12();

            let value = "1";
            if (newTimeOfDay.isMorning())
                value = "0";

            ampmSelect.getOption(value).setSelected(true);
        }
        //else 24 hour time
        else
            hourElm.value = this._integerToStringPad2(newTimeOfDay.getHourOfDay24());

        minElm.value = this._integerToStringPad2(newTimeOfDay.getMinuteOfHour());
    }

    this._integerToStringPad2 = function(i) {
        if (i >= 0 && i <= 9)
            return "0" + i;
        else
            return "" + i;
    }
}